import { useContext } from 'react';

import { HandshakeDataContext } from '../contexts/HandshakeDataContext';

export const useHandshakeData = () => useContext(HandshakeDataContext);
